import type { FuneralAssistanceParseResult } from './funeralAssistanceTypes';
import { parseZeloFile } from './parsers/zeloParser';

export async function parseFuneralAssistanceFile(file: File): Promise<FuneralAssistanceParseResult> {
  try {
    // Strategy Pattern: Detect provider based on file content or name
    // Currently only Zelo is supported.
    return await parseZeloFile(file);
  } catch (error) {
    console.error('[parseFuneralAssistanceFile] failed', error);
    throw error;
  }
}
